'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$$anon$99() {
  this.c4G = null;
  this.c4H = false;
}
export { $c_Lpresto_types$$anon$99 as $c_Lpresto_types$$anon$99 };
$p = $c_Lpresto_types$$anon$99.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$$anon$99;
/** @constructor */
function $h_Lpresto_types$$anon$99() {
}
export { $h_Lpresto_types$$anon$99 as $h_Lpresto_types$$anon$99 };
$h_Lpresto_types$$anon$99.prototype = $p;
$p.P = (function() {
  if ((!this.c4H)) {
    this.c4G = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.c4H = true;
  }
  return this.c4G;
});
var $d_Lpresto_types$$anon$99 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$$anon$99, "presto.types$$anon$99", ({
  Yv: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_types$$anon$99 as $d_Lpresto_types$$anon$99 };
//# sourceMappingURL=presto.types$$anon$99.js.map
